var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gradient-wrapper"},[_c('div',{staticClass:"canvas",attrs:{"id":"canvas-max"}},[_c('div',{staticClass:"gradient-canvas",style:({
        width: _vm.canvasCurrent.x,
        height: _vm.canvasCurrent.y,
        background: _vm.gradientStrings
      })},[_c('div',{staticClass:"preview-gradient",style:({ background: _vm.previewGradient })})])])])}
var staticRenderFns = []

export { render, staticRenderFns }